<template>
   <div class="row justify-content-center salesForm">
      <div v-if="!postMsg" class="col-md-12">
         <div class="form-wrapper">
            <form method="post" :action="action" @submit="onSubmit">
               <div class="card-group">
                  <div class="card card-1">
                     <div class="card-header pb-0">
                        <div class="card-heading-wrapper d-flex justify-content-center">
                           <h2 class="mb-1">{{ header }}</h2>
                        </div>
                     </div>
                     <div class="card-body">
                        <Fname ref="fnameComponent" :value="form.fname" />
                        <Lname ref="lnameComponent" :value="form.lname" />
                        <Email ref="emailComponent" :value="form.email" />
                        <Select
                           v-if="
                              purposeOptions.length === 0
                                 ? true
                                 : purposeOptions.length > 1 || loadSelect
                           "
                           ref="selectPurposeComponent"
                           :options="purposeOptions.length ? purposeOptions : purpose_options"
                           place-holder="Context"
                           invalid-feedback="What do you want to talk about?"
                           valid-feedback="Sounds good."
                           data-name="Context"
                           :selected-index="Number(selectedIndex)"
                        />
                        <!--<Name ref="nameComponent" :value="form.name" /> -->

                        <Country
                           ref="countryComponent"
                           data-name="country"
                           @CountryChanged="handleCountry"
                        />
                        <state ref="stateComponent" @StateChanged="handleState" />

                        <div class="row">
                           <div class="col-md-6 pr-md-1">
                              <Company ref="companyComponent" :value="form.company" />
                           </div>
                           <div class="col-md-6">
                              <Phone ref="phoneComponent" :value="form.phone" />
                           </div>
                        </div>

                        <!--<Message
                           ref="contextComponent"
                           message="Please enter your context here"
                           valid-feedback="Looks good."
                           :value="form.context"
                           :optional="false"
                        />-->

                        <Message
                           ref="messageComponent"
                           message="Please enter your question here"
                           valid-feedback="Looks good."
                           :value="form.message"
                           :optional="true"
                        />

                        <div class="d-none">
                           <!-- detecting country -->
                           <input v-getAutoCountryName type="hidden" />
                        </div>

                        <!-- Privacy checkbox-->
                        <div v-if="checkboxesHide" class="row">
                           <input
                              v-model="PrivacyCheck"
                              class="form-control gdpr-checkbox"
                              :class="[
                                 { 'is-invalid': isInValidTerms },
                                 { 'is-valid': isInValidTerms },
                              ]"
                              type="checkbox"
                              style="width:3%; height: 20px;"
                              name="TermsAndConditions"
                           />
                           <div class="col-md-11">
                              <label for="PrivacyCheckLabel">
                                 I have read, understand, and agree to FusionCharts's Terms of Use
                                 <a href="https://www.ideracorp.com/legal/FusionCharts#tabs-2"
                                    >Terms of Use</a
                                 >
                                 &
                                 <a href="https://www.ideracorp.com/Legal/PrivacyPolicy"
                                    >Privacy Statement</a
                                 >.
                              </label>
                           </div>
                           <!--<div class="invalid-feedback">Please agree?</div>
                           <div class="valid-feedback">Good toknow that.</div>-->
                           <div
                              v-if="isInValidTerms"
                              style="position:unset;padding-left: 34px;font-size: 14px;"
                              class="invalid-feedback"
                           >
                              Please Agree.
                           </div>
                        </div>

                        <!-- Marketing checkbox-->
                        <div v-if="checkboxesHideMarketing" class="row">
                           <input
                              v-model="form.MarketingCommunicationscheckbox"
                              class="form-control gdpr-checkbox"
                              :class="[
                                 { 'is-invalid': isInValidMarketingCommunicationscheckbox },
                                 { 'is-valid': isInValidMarketingCommunicationscheckbox },
                              ]"
                              type="checkbox"
                              style="width:3%;  height: 20px;"
                              name="MarketingCommunicationscheckbox"
                           />
                           <div class="col-md-11">
                              <label for="MarketingCheckLabel">
                                 I agree to receive marketing communication from FusionCharts for
                                 product updates, sales services, promotions, news, and events. I
                                 can withdraw my consent at any time and update my communication
                                 preference at the subscription center from any email received.
                                 <br />
                              </label>
                              <div
                                 v-if="isInValidMarketingCommunicationscheckbox"
                                 style="position: unset;padding-left: 16px;padding-bottom: 20px;font-size: 14px;color:red;"
                                 class=""
                              >
                                 Please Agree.
                              </div>
                           </div>

                           <!-- <div class="valid-feedback">Good to know that.</div>-->
                        </div>
                        <div class="col-md-12" style="padding:20px 0px;">
                           <vue-recaptcha
                              ref="recaptcha"
                              :sitekey="siteKey"
                              @verify="onVerify"
                              @error="errorMethod"
                              @expired="onCaptchaExpired"
                           ></vue-recaptcha>
                           <div v-if="captchaMsg" class="col-md-12">
                              Recaptcha Verification is failing
                           </div>
                        </div>

                        <button
                           type="submit"
                           :disabled="btnLoading"
                           class="btn btn-primary-grad btn-block mb-1"
                        >
                           <i v-if="btnLoading" class="loadingSpinner" />
                           <span>{{ submitText }}</span>
                        </button>
                        <div v-if="privacyPolicyHide" class="us_privacy_policy">
                           <small
                              ><strong>Note:</strong> By filling and submitting this form you
                              understand and agree that the use of FusionCharts’s website is subject
                              to the
                              <a href="https://www.ideracorp.com/Legal/Terms-of-Use"
                                 >General Website Terms of Use</a
                              >. Additional details regarding FusionCharts’s collection and use of
                              your personal information, including information about access,
                              retention, rectification, deletion, security, cross-border transfers
                              and other topics, is available in the
                              <a
                                 target="_blank"
                                 rel="noopener noreferrer"
                                 href="https://www.ideracorp.com/Legal/PrivacyPolicy"
                                 >Privacy Policy </a
                              >.
                           </small>
                        </div>
                     </div>
                  </div>
               </div>
               <input type="hidden" name="MarketingCommunications" />
               <input type="hidden" :value="form.elqFormName" name="elqFormName" />
               <input type="hidden" :value="form.elqSiteId" name="elqSiteId" />
               <input type="hidden" value="FusionCharts" name="Topic" />
               <input type="hidden" :value="form.Source" name="Source" />
               <input type="hidden" :value="form.Medium" name="Medium" />
               <input type="hidden" :value="form.Content" name="Content" />
               <input type="hidden" :value="form.Campaign" name="Campaign" />
               <input type="hidden" :value="form.SearchTerm" name="SearchTerm" />
               <input type="hidden" :value="form.returnURL" name="retURL" />
               <input type="hidden" :value="this.$route.query.ba" name="banner" />
            </form>
         </div>
      </div>
      <div v-if="postMsg" class="col-12 text-center">
         <h1 class="mb-1">Thanks for contacting us.</h1>
         <p class="subheading">One of our sales representatives will get in touch with you soon.</p>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import { VueRecaptcha } from 'vue-recaptcha';
// mport $service from '../../util/service.js';
import Fname from './elements/Fname';
import Lname from './elements/Lname';
import Email from './elements/Email';
import Company from './elements/Company';
import Phone from './elements/Phone';
import Message from './elements/Message';
import Country from './elements/Country';
import State from './elements/State';
import Select from './elements/Select';

export default {
   name: 'SalesForm',

   components: {
      Lname,
      Fname,
      Email,
      Company,
      Phone,
      Message,
      Country,
      State,
      Select,
      VueRecaptcha,
   },

   props: {
      purposeOptions: {
         type: Array,
         default: () => [],
      },

      selectedIndex: {
         type: [Number, String],
         default: -1,
      },

      siteKey: {
         type: String,
         default: '6LdvDO4ZAAAAAKMdq4Df6X5PVRdrmPxEgtwpvTcC',
      },

      header: {
         type: String,
         default: 'Contact a sales representative',
      },

      submitText: {
         type: String,
         default: 'CONTACT SALES',
      },

      source: {
         type: String,
         default: 'Topbar',
      },
   },

   data() {
      return {
         isInValidMarketingCommunicationscheckbox: false,
         isInValidTerms: false,
         isInvalidState: false,
         btnLoading: false,
         postMsg: false,
         captchaMsg: false,
         isValidCaptcha: false,
         checkboxesHide: true,
         checkboxesHideMarketing: false,
         privacyPolicyHide: true,
         attemptSubmit: false,
         loadSelect: false,
         ...(process.browser && { checkout: this.$tracker.checkout }),
         PrivacyCheck: false,
         MarketingCheck: false,
         purpose_options: [
            {
               value: 'Licensing query for a SaaS application',
               text: 'Licensing query for a SaaS application',
            },
            {
               value: 'Licensing query for an on-premise application (OEM)',
               text: 'Licensing query for an on-premise application (OEM)',
            },
            {
               text: 'Licensing query for an enterprise plan',
               value: 'licensing-query-for-an-enterprise-plan',
            },
            {
               value: 'Licensing FusionGrid',
               text: 'Licensing FusionGrid',
            },
            {
               text: 'Reseller enquiry',
               value: 'Reseller enquiry',
            },
            {
               value: 'Licensing FusionExport',
               text: 'Licensing FusionExport',
            },
            {
               value: 'Licensing query for an on-premise application',
               text: 'Licensing query for an on-premise application',
            },
            { value: 'Payment through PO/Wire/Check', text: 'Payment through PO/Wire/Check' },
            { value: '​Product/Technical related query', text: '​Product/Technical related query' },
            { value: 'other', text: 'Other' },
         ],
         form: {
            Context: '',
            lastName: '',
            firstName: '',
            emailAddress: '',
            email: '',
            company: '',
            busPhone: '',
            YourQuestion: '',
            country: '',
            stateProv: '',
            TermsAndConditions: false,
            MarketingCommunicationscheckbox: false,
            MarketingCommunications: false,
            ProdInterestArea_FC: '',
            ProdInterestArea: '',
            OrderType: '',
            Topic: 'FusionCharts',
            robot: true,
            Source: '',
            Medium: '',
            Campaign: '',
            Content: '',
            SearchTerm: '',
            elqFormName: '',
            elqSiteId: '',
            returnURL: '',
         },
         action: 'https://e/f2',
      };
   },

   computed: {
      ...mapState(['csrfToken']),
   },

   created() {
      if (this.$route.path.indexOf('/contact-sales') > -1) {
         this.loadSelect = true;
      }
   },

   methods: {
      updateFormData() {
         // this.form.name = this.$refs.nameComponent.form.name;
         this.form.firstName = this.$refs.fnameComponent.form.fname;
         this.form.lastName = this.$refs.lnameComponent.form.lname;
         this.form.emailAddress = this.$refs.emailComponent.form.email;
         this.form.email = this.$refs.emailComponent.form.email;
         this.form.company = this.$refs.companyComponent.form.company;
         this.form.country = this.$refs.countryComponent.form.country;
         this.form.stateProv = this.$refs.stateComponent.form.state;
         this.form.TermsAndConditions = this.PrivacyCheck;
         this.form.MarketingCommunicationscheckbox = this.form.MarketingCommunicationscheckbox;
         this.form.busPhone = this.$refs.phoneComponent.form.phone;
         this.form.YourQuestion = this.$refs.messageComponent.form.message;
         const selectElem = this.$refs.selectPurposeComponent;

         this.form.Context = selectElem ? selectElem.form.data : this.purposeOptions[0].value;
         // this.form.elqFormName = 'FC-ContactSales-TNew';
         //  this.form.elqSiteId = '608';
         this.form.OrderType = 'Contact Sales';
         this.form.ProdInterestArea = 'FC';
         this.form.ProdInterestArea_FC = '1';
         // this.form.Topic = 'FusionCharts';
         // this.form.userSource = this.$getCookie('utm_campaign');
         if (this.$getCookie('utm_source')) {
            this.form.Source = this.$getCookie('utm_source');
         } else {
            this.form.Source = 'WI';
         }
         if (this.$getCookie('utm_medium')) {
            this.form.Medium = this.$getCookie('utm_medium');
         } else {
            this.form.Medium = 'Direct';
         }
         if (this.$getCookie('utm_content')) {
            this.form.Content = this.$getCookie('utm_content');
         }
         if (this.$getCookie('utm_campaign')) {
            this.form.Campaign = this.$getCookie('utm_campaign');
         }
         if (this.$getCookie('utm_term')) {
            this.form.SearchTerm = this.$getCookie('utm_term');
         }
         if (
            document.getElementsByName('TermsAndConditions') !== undefined &&
            document.getElementsByName('TermsAndConditions').length > 0
         ) {
            if (this.PrivacyCheck === true) {
               document.getElementsByName('TermsAndConditions')[0].value = 1;
               // this.PrivacyCheck = 1;
            } else {
               document.getElementsByName('TermsAndConditions')[0].value = 0;
               // this.PrivacyCheck = 0;
            }
         }
         if (
            document.getElementsByName('MarketingCommunicationscheckbox') !== undefined &&
            document.getElementsByName('MarketingCommunicationscheckbox').length > 0
         ) {
            if (this.form.MarketingCommunicationscheckbox === true) {
               document.getElementsByName('MarketingCommunicationscheckbox')[0].value = 1;
               document.getElementsByName('MarketingCommunications')[0].value = 1;
            } else {
               document.getElementsByName('MarketingCommunicationscheckbox')[0].value = 0;
               document.getElementsByName('MarketingCommunications')[0].value = 0;
               if (
                  document.getElementById('TermsAndConditions') !== undefined &&
                  this.PrivacyCheck === true
               ) {
                  document.getElementsByName('MarketingCommunications')[0].value = 0;
               }
            }
         }
      },
      validateFormData() {
         this.$refs.emailComponent.validateMailData();
         this.$refs.fnameComponent.validateFnameData();
         this.$refs.fnameComponent.validateFnameData();
         this.$refs.lnameComponent.validateLnameData();
         // this.$refs.nameComponent.validateNameData();
         this.$refs.companyComponent.validateCompanyData();
         this.checkCountry(this.form.country);
         if (this.form.country === 'US' || this.form.country === 'CA') {
            this.$refs.stateComponent.validatestateData();
            if (this.$refs.stateComponent.isValidName.isInvalid === true) {
               this.isInvalidState = true;
            } else {
               this.isInvalidState = false;
            }
         } else {
            this.isInvalidState = false;
         }
         // when you need a reCAPTCHA challenge
         // this.$refs.recaptcha.execute();

         if (this.isValidCaptcha === false) {
            this.captchaMsg = true;
         }
         this.$refs.phoneComponent.validatePhoneData();
         this.$refs.messageComponent.validateMessageData();
         const selectElem = this.$refs.selectPurposeComponent;
         selectElem && selectElem.validateFieldData();
         if (this.checkboxesHideMarketing === true) {
            // this.validateMarketingCommunicationscheckboxData();
         } else {
            this.isInValidMarketingCommunicationscheckbox = false;
         }
         if (this.checkboxesHide === true) {
            this.validatePrivacyCheck();
         } else {
            this.isInValidTerms = false;
         }
      },
      /* validateMarketingCommunicationscheckboxData() {
         if (this.form.MarketingCommunicationscheckbox === false) {
            this.isInValidMarketingCommunicationscheckbox = true;
         } else {
            this.isInValidMarketingCommunicationscheckbox = false;
         }
      }, */
      validatePrivacyCheck() {
         if (this.form.TermsAndConditions === false) {
            this.isInValidTerms = true;
         } else {
            this.isInValidTerms = false;
         }
      },
      onVerify(response) {
         if (response) {
            this.form.robot = true;
            this.captchaMsg = false;
            this.isValidCaptcha = true;
         }
      },
      errorMethod(response) {
         if (response) {
            this.$refs.recaptcha.reset();
            this.form.robot = false;
            this.captchaMsg = true;
         }
      },

      onCaptchaExpired() {
         this.$refs.recaptcha.reset();
      },
      checkCountry(key) {
         this.$refs.stateComponent.getstates(key);
         if (
            key === 'BE' ||
            key === 'BG' ||
            key === 'CZ' ||
            key === 'DE' ||
            key === 'EE' ||
            key === 'IE' ||
            key === 'EL' ||
            key === 'ES' ||
            key === 'FR' ||
            key === 'IT' ||
            key === 'CY' ||
            key === 'LV' ||
            key === 'LT' ||
            key === 'HR' ||
            key === 'LU' ||
            key === 'HU' ||
            key === 'MT' ||
            key === 'NL' ||
            key === 'AT' ||
            key === 'PL' ||
            key === 'PT' ||
            key === 'RO' ||
            key === 'SI' ||
            key === 'SK' ||
            key === 'FI' ||
            key === 'SE' ||
            key === 'UK' ||
            key === 'CA' ||
            key === 'GR' ||
            key === 'GB' ||
            key === 'CH' ||
            key === 'AU' ||
            key === 'NO' ||
            key === 'EU' ||
            key === 'NZ'
         ) {
            this.checkboxesHideMarketing = true;
         } else {
            this.checkboxesHideMarketing = false;
         }
      },
      handleCountry(e) {
         this.checkCountry(e.key);
      },
      handleState(e) {
         if (
            this.$refs.countryComponent.form.country === 'US' &&
            this.$refs.stateComponent.form.state === 'CA'
         ) {
            // this.checkboxesHide = true;
            this.checkboxesHideMarketing = true;
         } else {
            // this.checkboxesHide = false;
            // this.checkboxesHideMarketing = false;
         }
      },
      onSubmit(evt) {
         // evt.preventDefault();
         if (this.form.robot) {
            this.attemptSubmit = true;
            // validation and form update
            this.updateFormData();
            this.validateFormData();

            this.form._csrf = this.csrfToken;
            this.form.source = this.$route.path;

            if (
               this.missingName &&
               !this.isValidEmail &&
               this.$refs.emailComponent.isValidMail.isValid &&
               !this.isNotEmpty(this.form.company) &&
               !this.isNotEmpty(this.form.firstName) &&
               !this.isNotEmpty(this.form.lastName) &&
               !this.isNotEmpty(this.form.country) &&
               !this.isNotEmpty(this.form.busPhone) &&
               this.form.purpose !== '' &&
               this.isInvalidState === false &&
               this.isInValidTerms === false &&
               this.isInValidMarketingCommunicationscheckbox === false &&
               this.form.Context !== '' &&
               this.isValidCaptcha === true
            ) {
               this.btnLoading = true;

               window.dataLayer = window.dataLayer || [];
               window.dataLayer.push({
                  event: 'salesinquiryformSubmissionSuccess',
               });
               this.form.returnURL = `https://www.fusioncharts.com/contact-us/thank-you?email=${this.form.emailAddress}&phone=${this.form.busPhone}`;

               /* $service
                  .post(this.action, this.form)
                  .then(response => {
                     if (response.status === 200) {
                        this.postMsg = true;
                        this.captchaMsg = false;
                     }
                  })
                  .catch(err => console.error('fail', err)); */
               this.form.elqFormName = 'FC-ContactSales-TNew';
               this.form.elqSiteId = '608';
               this.action = 'https://s608.t.eloqua.com/e/f2';
               // this.$http.post(this.action, { data: this.form });
               /* $.ajax({
                  url: 'http://sXXX.t.eloqua.com/e/f2',
                  type: 'post',
                  data: $(this).serialize(),
                  success(html) {
                     cosole.log('Success');

                     $('.myForm').hide();
                  },
               }); */
            } else {
               evt.preventDefault();
            }
         } else {
            // this.updateFormData();
            this.attemptSubmit = true;
            // validation and form update
            this.updateFormData();
            this.validateFormData();
            this.captchaMsg = true;
            evt.preventDefault();
         }
      },
   },
};
</script>
<style>
.gdpr-checkbox {
   margin-top: 7px;
}
</style>
